import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import styles from '../screens/EventsScreen.styles';

interface WeekSelectorProps {
  selectedWeekStart: string; // YYYY-MM-DD (Monday)
  onWeekChange: (weekStart: string) => void;
}

function getWeekRangeLabel(weekStart: string): string {
  const start = new Date(weekStart + 'T12:00:00');
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const startDay = start.getDate();
  const endDay = end.getDate();
  const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
  const endMonth = end.toLocaleDateString('en-US', { month: 'short' });
  const year = end.getFullYear();
  if (startMonth === endMonth) {
    return `${startDay} - ${endDay} ${startMonth} ${year}`;
  }
  return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${year}`;
}

function addWeeks(weekStart: string, delta: number): string {
  const d = new Date(weekStart + 'T12:00:00');
  d.setDate(d.getDate() + 7 * delta);
  return d.toISOString().slice(0, 10);
}

export const WeekSelector: React.FC<WeekSelectorProps> = ({
  selectedWeekStart,
  onWeekChange,
}) => {
  const label = getWeekRangeLabel(selectedWeekStart);

  return (
    <View style={styles.weekSelector}>
      <TouchableOpacity
        style={[styles.weekButton, styles.weekButtonInactive]}
        onPress={() => onWeekChange(addWeeks(selectedWeekStart, -1))}
      >
        <Text style={styles.weekButtonTextInactive}>←</Text>
      </TouchableOpacity>
      <View style={[styles.weekButton, styles.weekButtonActive, { flex: 1, justifyContent: 'center' }]}>
        <Text style={[styles.weekButtonText, styles.weekButtonTextActive]} numberOfLines={1}>
          {label}
        </Text>
      </View>
      <TouchableOpacity
        style={[styles.weekButton, styles.weekButtonInactive]}
        onPress={() => onWeekChange(addWeeks(selectedWeekStart, 1))}
      >
        <Text style={styles.weekButtonTextInactive}>→</Text>
      </TouchableOpacity>
    </View>
  );
};
